import React, { useState, useContext, useEffect, useImperativeHandle, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { AccountContext } from "context/account";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiTagInput from "components/SuiTagInput";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import NumbersIcon from "@mui/icons-material/Numbers";
import EditIcon from "@mui/icons-material/Edit";
import UploadIcon from "@mui/icons-material/Upload";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import toast from "react-hot-toast";

import CategoryContext from "context/category-context";

import api from "services/api";
import moment from "moment";
import { Upload } from "antd";

import { materialCategoryOptions } from "utils/data";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import Tooltip from "@mui/material/Tooltip";
import * as XLSX from "xlsx";
import DataTable from "examples/Tables/DataTable";

const ImportExcelModal = ({
  visible,
  handleClose,
  handleOk,
  handleRefresh = () => {},
  excelData,
}) => {
  const [workbook, setWorkbook] = useState(excelData);
  const [selectedSheetName, setSelectedSheetName] = useState();
  const [sheetData, setSheetData] = useState([]);

  useEffect(() => {
    if (workbook && workbook?.SheetNames.length > 0) {
      setSelectedSheetName(workbook.SheetNames[0]);
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      setSheetData(data);
    }
  }, [workbook]);

  const handleSheetNameOnChange = (value) => {
    setSelectedSheetName(value);
    const sheet = workbook.Sheets[value];
    const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });
    setSheetData(data);
  };

  let columns = [];

  let rows = [];

  for (let i = 0; i < sheetData.length; i++) {
    let temp = {};
    for (let j = 0; j < sheetData[i].length; j++) {
      if (i == 0) {
        let headerName = sheetData[i][j] ? sheetData[i][j] : "" + j;
        columns.push({ Header: headerName, accessor: j.toString() });
      } else {
        let key = j;
        let value = sheetData[i][j];

        temp[key] = value;
      }
    }
    if (i != 0) {
      rows.push(temp);
    }
  }

  return (
    <Dialog
      open={visible}
      onClose={(e, reason) => {
        if (reason != "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">
        <SuiBox display="flex" gap={1}>
          Import Excel
        </SuiBox>

        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <SuiBox px={2}>
            <SuiTypography variant="h6">Sheets:</SuiTypography>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              {workbook && workbook?.SheetNames.length > 0
                ? workbook?.SheetNames.map((sn) => (
                    <FormControlLabel
                      value={sn}
                      control={<Radio />}
                      label={
                        <SuiTypography variant="body1" sx={{ mr: 1 }}>
                          {sn}
                        </SuiTypography>
                      }
                      checked={sn == selectedSheetName}
                      onChange={(e) => (e.target.checked ? handleSheetNameOnChange(sn) : null)}
                    />
                  ))
                : null}
            </RadioGroup>
          </SuiBox>

          <DataTable
            table={{ columns: columns, rows: rows }}
            entriesPerPage={{ defaultValue: 10 }}
            noEndBorder
          />

          <SuiBox
            pt={3}
            px={3}
            display="flex"
            justifyContent="end"
            alignItems={{ xs: "flex-start", sm: "center" }}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <SuiBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
              <SuiBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
                <SuiButton variant="gradient" size="medium" onClick={handleClose} color="light">
                  Cancel
                </SuiButton>
              </SuiBox>
            </SuiBox>
            <SuiBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
              <SuiBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
                <SuiButton
                  size="medium"
                  variant="gradient"
                  color="dark"
                  onClick={() => {
                    handleOk(sheetData);
                    handleClose();
                  }}
                >
                  Import
                </SuiButton>
              </SuiBox>
            </SuiBox>
          </SuiBox>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default ImportExcelModal;
